import * as tf from "@tensorflow/tfjs";
import coxParameters from "./outcome_crt.json";
import logregParameters from "./response_crt.json";
import crtScaler from "./scaler_crt.json";

const significantDimensions = [0, 4, 5, 7, 8, 9, 10, 11, 12, 14, 15, 16, 18, 21, 22, 24, 25, 26, 29, 30, 31];
const significantSDs = significantDimensions.map((i) => crtScaler.sd[i]);
const significantMeans = significantDimensions.map((i) => crtScaler.mean[i]);

async function getCoxPrediction(encoding: number[]): Promise<any> {
  const significantEncoding = significantDimensions.map((i) => encoding[i]);

  return await tf
    .sub(
      1,
      tf.pow(
        coxParameters.baseline_survival,
        tf.exp(tf.dot(tf.tensor1d(coxParameters.coefs), tf.mul(tf.sub(significantEncoding, significantMeans), significantSDs)))
      )
    )
    .array();
}

async function getLogRegPrediction(encoding: number[]): Promise<any> {
  const significantEncoding = significantDimensions.map((i) => encoding[i]);
  return await tf
    .sigmoid(
      tf.add(
        logregParameters.intercept,
        tf.dot(tf.tensor1d(logregParameters.coefs), tf.mul(tf.sub(significantEncoding, significantMeans), significantSDs))
      )
    )
    .array();
}

export default [
  {
    id: "CRT/Outcome",
    value: "CRT/Outcome",
    label: "CRT / Outcome",
    patientGroup: "Patients that are screened for CRT",
    predictedOutcome: "Three-year risk of LVAD/HTx/death",
    link: "https://crt.ecgx.ai",
    paper: {
      text: `This model was trained on 1306 patients screened for 
        cardiac resynchronization therapy (CRT) in three academic 
        hospitals to predict the three-year risk of left ventricular 
        assist device implantation, heart transplantation or 
        all-cause death (LVAD/HTx/death). Results are currently 
        under review.`,
      link: "",
    },
    baseValue: 17,
    colors: coxParameters.colors,
    probability: getCoxPrediction,
  },
  {
    id: "CRT/Response",
    value: "CRT/Response",
    label: "CRT / Response",
    patientGroup: "Patients that are screened for CRT",
    predictedOutcome: "Predicted risk of non-response",
    link: "https://crt.ecgx.ai",
    paper: {
      text: `This model was trained on 821 patients screened for 
      cardiac resynchronization therapy (CRT) in three academic 
      hospitals to predict the risk of non-response (i.e. left 
        ventricular end systolic volume reduction of less than 
        15%). Results are currently under review.`,
      link: "",
    },
    baseValue: 44,
    colors: logregParameters.colors,
    probability: getLogRegPrediction,
  },
];
